/** @jsx jsx */
import { Dialog } from '@datacamp/waffles/dialog';
import { ExternalLink } from '@datacamp/waffles/icon';
import { Paragraph } from '@datacamp/waffles/paragraph';
import { tokens } from '@datacamp/waffles/tokens';
import { jsx } from '@emotion/react';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import courseNotesPng from '../../assets/images/course_notes.png';
import { isFeatureEnabled } from '../../helpers/featureFlags';
import { useDispatch } from '../../interfaces/State';
import { removeModal } from '../../redux/actions';

import { useCourseNotes } from './hooks/useCourseNotes';

const CourseNotesModal: React.FC = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { openCourseNotes } = useCourseNotes();
  const isDatalabEnabled = isFeatureEnabled('collab--enable-datalab');

  const onClick = useCallback(() => {
    openCourseNotes({ force: true });
    dispatch(removeModal());
  }, [dispatch, openCourseNotes]);

  return (
    <>
      <img
        src={courseNotesPng}
        css={{
          borderBottom: `${tokens.borderWidth.thin} solid ${tokens.colors.transparentGrey}`,
        }}
        alt={t('Notes.imgAlt')}
      />
      <Dialog.Header>{t('Notes.title')}</Dialog.Header>
      <Dialog.Body>
        <Paragraph>
          {isDatalabEnabled
            ? t('Notes.datalabParagraph')
            : t('Notes.paragraph')}
        </Paragraph>
      </Dialog.Body>
      <Dialog.Footer>
        <Dialog.Button
          variant="primary"
          size="medium"
          onClick={onClick}
          data-cy="open-notes-button"
          iconRight={<ExternalLink />}
        >
          {t('Notes.cta')}
        </Dialog.Button>
      </Dialog.Footer>
    </>
  );
};

export default CourseNotesModal;
